import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';
import userStore from './user';
import ticketStore from './ticket';
import createStore from './create';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common: common,
        user: userStore,
        ticket: ticketStore,
        create: createStore,
    },
});
